import React from 'react';
import PropTypes from 'prop-types';
import Link from 'components/Link';
import classNames from 'classnames';
import { sendGAEvent } from '../../../utils';
import s from './Heading.scss';

const Heading = props => {
  const { text, type, url, ga, className, urlTarget } = props;

  if (!text) {
    return null;
  }
  const headingTypeClass = classNames({
    [s.h1]: type === 'h1',
    [s.h2]: type === 'h2',
    [s.h3]: type === 'h3',
  });

  let heading = '';
  const headingClass = `${headingTypeClass} ${s.heading_element} ${
    !url ? `${s.heading} ${className}` : ''
  }`;
  switch (type) {
    case 'h1':
      heading = <h1 className={headingClass}>{text}</h1>;
      break;
    case 'h2':
      heading = <h2 className={headingClass}>{text}</h2>;
      break;
    default:
      heading = <h3 className={headingClass}>{text}</h3>;
  }

  return (
    <>
      {url ? (
        <Link
          className={`${s.heading} ${className}`}
          to={url}
          target={urlTarget}
          onClick={() => {
            sendGAEvent({
              ...ga,
              action: `${ga.action}_Header`,
            });
          }}
        >
          {' '}
          {heading}
          <span />
        </Link>
      ) : (
        <>{heading}</>
      )}
    </>
  );
};

Heading.propTypes = {
  text: PropTypes.string.isRequired,
  type: PropTypes.string,
  url: PropTypes.string,
  ga: PropTypes.shape({
    category: PropTypes.string,
    action: PropTypes.string,
  }),
  className: PropTypes.string,
  urlTarget: PropTypes.string,
};

Heading.defaultProps = {
  type: 'h3',
  url: '',
  ga: {
    category: '',
    action: '',
  },
  className: '',
  urlTarget: undefined,
};

export default Heading;
